import { useState } from "react";
import AuthLayout from "../components/AuthLayout";
import { supabase } from "../services/supabase";

export default function RegistrationCheckEmail({
  email,
  onBackToLogin,
}) {
  const [resending, setResending] = useState(false);

  const handleResend = async () => {
    setResending(true);
    try {
      const { error } = await supabase.auth.resend({
        type: "signup",
        email,
      });
      if (error) throw error;
      alert("Verification email sent! Please check your inbox.");
    } catch {
      alert("Failed to resend email. Please try again.");
    } finally {
      setResending(false);
    }
  };

  return (
    <AuthLayout>

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md text-center">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Verify your email!
            </h1>

            <p className="text-gray-500 max-w-sm mx-auto mb-6">
              We've sent a verification email to{" "}
              <span className="font-semibold text-gray-700">{email}</span>
            </p>

            <p className="text-gray-500 max-w-sm mx-auto">
              Please click the link in the email to verify your account and
              complete your registration.
            </p>
          </div>

          <button
            onClick={handleResend}
            disabled={resending}
            className="w-full bg-[#06402B] text-white py-3 rounded-full font-medium hover:bg-green-900 transition-colors mb-4 disabled:opacity-50"
          >
            {resending ? "Sending..." : "Resend Verification Email"}
          </button>

          <button
            onClick={onBackToLogin}
            className="w-full flex items-center justify-center gap-2 text-gray-700 py-2 hover:underline"
          >
            ← Back to Login
          </button>

          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg text-sm text-left">
            <p className="font-semibold text-blue-900 mb-2">
              📧 Didn't receive the email?
            </p>
            <ul className="text-blue-700 space-y-1 ml-4">
              <li>• Check your spam/junk folder</li>
              <li>• Make sure you entered the correct email</li>
              <li>• Click "Resend" to get a new verification email</li>
            </ul>
          </div>
        </div>
      </main>
</AuthLayout>
  );
}
